export default __webpack_public_path__ + "static/input-selection-state-ad9cf4b13124142b8663466b3e74bad3.png";